import { useBooleanState } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ExplanationPopup } from './explanation_popup';
import { OrganizerOptionList } from './organizer_option_list';
const getLabelText = kind => ({
  google_conference: I18n.t('publisher.event_types.location.google_conference.label'),
  gotomeeting_conference: I18n.t('publisher.event_types.location.gotomeeting_conference.label'),
  zoom_conference: I18n.t('publisher.event_types.location.zoom_conference.label'),
  microsoft_teams_conference: I18n.t('publisher.event_types.location.microsoft_teams_conference.label'),
  webex_conference: I18n.t('publisher.event_types.location.webex_conference.label')
})[kind];
const styledLinkCss = "s1rk5xvp";
const StyledLink = forwardRef((props, ref) => <Link ref={ref} {...props} className={classNames(styledLinkCss, props.className)} />);
const organizerWrapperCss = "o1ppxsaq";
const OrganizerWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(organizerWrapperCss, props.className)} />;
});
export const OrganizerSection = ({
  memberships,
  currentOrganizer,
  validLocationKind,
  onSelect,
  pendingOrganizer
}) => {
  const locationName = getLabelText(validLocationKind);
  const [toggleOrganizerDropdown, OrganizerDropdown] = useDropdown();
  const linkDisabled = ['google_conference', 'microsoft_teams_conference'].includes(validLocationKind);
  const [isExplanationPopupOpen, showExplanationPopup, hideExplanationPopup] = useBooleanState(false);
  const organizerDisplayName = pendingOrganizer ? I18n.t('publisher.event_type_editor.sections.event_details.fields.location.automatic') : currentOrganizer?.name;
  if (linkDisabled) {
    return <>
        <BodyText>
          <StyledLink underline={false} as="button" onClick={showExplanationPopup}>{organizerDisplayName}</StyledLink>
        </BodyText>
        {isExplanationPopupOpen && <ExplanationPopup locationKind={validLocationKind} isOpen={isExplanationPopupOpen} onClose={hideExplanationPopup} />}
      </>;
  }
  return <OrganizerWrapper onClick={null}>
      <BodyText>
        {I18n.t('publisher.event_type_editor.sections.event_details.fields.location.organizer_label', {
        type: locationName
      })}
        <StyledLink underline={false} as="button" onClick={toggleOrganizerDropdown}>
          {organizerDisplayName}
          <ArrowChevronDownMiniIcon spacingTop={4} />
        </StyledLink>
      </BodyText>
      <OrganizerDropdown>
        <OrganizerOptionList organizerOptions={memberships} updateOrganizer={onSelect} />
      </OrganizerDropdown>
    </OrganizerWrapper>;
};

require("./organizer_dropdown.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./organizer_dropdown.js");